"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ramda = require("ramda");

var _ipath = require("ipath");

var _common = require("./common");

var _default = function _default(l) {
  l = (0, _common.attachDefault)(l);
  var keys = Object.keys(l);
  return function () {
    var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var a = arguments.length > 1 ? arguments[1] : undefined;
    if ((0, _ramda.unnest)(keys.map(function (k) {
      return (0, _common.toHttpMethods)(k, l[k]);
    })).some(function (m) {
      return m[1].indexOf(a.type) > -1;
    })) return Object.assign({}, s, {
      isLoading: true,
      error: null
    });
    if (keys.map(_common.toSet).indexOf(a.type) === -1) return s; // if (a.error)
    //   return Object.assign({}, s, { error: a.error, isLoading: false });

    var path = a.path;

    if (path.length > 0 && a.method === 'post') {
      // restful post to array
      if ((0, _ramda.last)(path) === ']' && (0, _ramda.takeLast)(2, path) !== '[]') path = path.slice(0, path.lastIndexOf('[')) + '[]';
    }

    var state = Object.assign({}, s, {
      isLoading: false,
      lastAction: a.type,
      error: a.error
    });
    var value = (0, _ramda.is)(Function, a.payload) ? a.payload(state) : a.payload;
    return (0, _ipath.update)(state, path, value, a.params || value, a.method === 'patch'); // const idx = last(path);
    // if (is(Number, idx)) {
    //   const arr = init(path);
    //   if (isNil(a.payload)) // delete
    //     return over(lensPath(arr), remove(idx, 1), state);
    //   if (a.method === 'patch') {
    //     return reduce(
    //       (p, c) => set(lensPath(append(c, path)), a.payload[c], p),
    //       state,
    //       Object.keys(a.payload)
    //     );
    //   }
    //   if (idx === 0 && isNil(view(lensPath(arr), state)))
    //     state = set(lensPath(arr), [], state);
    // }
    // else if (idx instanceof Error) {
    //   state.error = {
    //     source: a.type,
    //     text: idx.message
    //   };
    //   return state;
    // }
    // return set(lensPath(path), a.payload, state);
  };
};

exports.default = _default;